import O10g015460Store from './store/O10g015460Store';

export default {
  o10g015460Store: O10g015460Store.instance,
};
